/**
 * Created by Kaku.Guo on 2018/10/29.
 */
import axios from 'axios';
import Url from '../constants/Url';

class AssetApi {
    listAssets(params) {
        return axios.get(Url().ASSET.LIST, { params })
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }

    suggestAssets(params) {
        return axios.get(Url().ASSET.SUGGEST, { params })
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }

    vaultAssets(params) {
        return axios.get(Url().ASSET.VAULT, { params })
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }

    getHomeData() {
        return axios.get(Url().HOME_DATA.GET)
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }

    getAsset(slug) {
        return axios.get(Url().ASSET.GET(slug))
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }

    getItem(item) {
        return axios.get(Url().ASSET.ITEM(item))
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }

    sellerAssets({sellerName, ...params}) {
        return axios.get(Url().ASSET.SELLER(sellerName), { params })
            .then(response => response.data.data)
            .catch((ex) => { throw ex; });
    }
}
export default new AssetApi();